import { render, staticRenderFns } from "./_PostponeAutoShutdownPopup.vue?vue&type=template&id=52fd60fd"
import script from "./_PostponeAutoShutdownPopup.vue?vue&type=script&lang=ts"
export * from "./_PostponeAutoShutdownPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports